<template>
    <div>
        <div class="row">
            <div
                v-if="loading"
                class="col-12 mt-5"
                v-loading="true"></div>
            <div v-else class="col-md-12">
                <div class="d-flex mb-3">
                    <el-input
                        v-model="nameFilter"
                        placeholder="Filter by name"
                        @keyup.native="filterActivities(true)"/>
                </div>
                <card>
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Activities</span>
                            <div>
                                <!-- <el-tooltip content="Repopulate All Registrations" placement="top" v-if="user.admin">
                                    <el-button @click="repopulateAll" :loading="repopulatingAll" class="btn btn-default">
                                        <fa v-if="!repopulatingAll" icon="undo"/>
                                    </el-button>
                                </el-tooltip> -->
                                <el-tooltip content="Download" placement="top" v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].downloadReports))">
                                    <el-button
                                        type="default"
                                        class="btn btn-default mr-1"
                                        :loading="downloading"
                                        @click="downloadActivities()">
                                            <fa icon="download"/>
                                    </el-button>
                                </el-tooltip>
                                <router-link v-if="(user.admin || (user.roles && user.roles[this.$route.params.eventId] && user.roles[this.$route.params.eventId].editRegistrationTypes))" :to="{ name: 'activities-create' }">
                                    <el-button class="btn btn-primary">
                                            Add
                                    </el-button>
                                </router-link>
                            </div>
                        </div>
                    </template>
                    <el-table :data="activities" ref="activitiesTable" class="header-background" stripe border>
                        <el-table-column label="Count" prop="availableSeats" min-width="100px"/>
                        <el-table-column label="Details" prop="name" min-width="150px"/>
                        <el-table-column label="Registered" min-width="150px">
                            <template slot-scope="props">
                                <router-link :is="!(user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrants)) ? 'span' : 'router-link'" :to="{ name: 'activity-attendees', params: { activityId: props.row._id } }">
                                    {{ props.row.registeredAttendees.length }}
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="Checked In" min-width="150px">
                            <template slot-scope="props">
                                <router-link :is="!(user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].viewRegistrants)) ? 'span' : 'router-link'" :to="{ name: 'activity-attendees', params: { activityId: props.row._id }, query: { checkins: true } }">
                                    {{ props.row.checkedInAttendees.length }}
                                </router-link>
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions" :width="450">
                            <template slot-scope="props">
                                <el-tooltip content="Toggle Enable Scan" placement="top" v-if="user.admin">
                                    <el-switch
                                        v-model="props.row.scanEnabled"
                                        @change="toggleEnableScan(props.row._id)"
                                        class="mr-4"
                                        style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949"
                                    />
                                </el-tooltip>
                                <router-link
                                    v-if="user.admin || (props.row.scanEnabled && event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].checkinActivities)"
                                    :to="{ name: 'scanner', params: { type: 'activity', id: props.row._id } }">
                                        <el-tooltip content="Scan" placement="top">
                                            <el-button class="btn" title="Scan">
                                                <fa :icon="['fas', 'qrcode']"/>
                                            </el-button>
                                        </el-tooltip>
                                </router-link>
                                
                                <span v-if="user.admin || (props.row.scanEnabled && event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].checkinActivities)">
                                    <el-tooltip content="Repopulate" placement="top">
                                        <el-button @click="repopulate(props.row._id)" :loading="repopulating" class="btn btn-default ml-1">
                                            <fa v-if="!repopulating" icon="undo"/>
                                        </el-button>
                                    </el-tooltip>   
                                </span>
                                
                                <router-link v-if="(user.admin || (user.roles && user.roles[eventId] && user.roles[eventId].editRegistrationTypes))" :to="{ name: 'activities-edit', params: { activityId: props.row._id } }">
                                    <el-tooltip content="Edit" placement="top">
                                        <el-button class="btn ml-1" title="Edit">
                                            <fa :icon="['fas', 'pen']"/>
                                        </el-button>
                                    </el-tooltip>
                                </router-link>
                                <el-tooltip content="Clone" placement="top" v-if="(user.admin || (user.roles && user.roles[eventId] && user.roles[eventId].editRegistrationTypes))">
                                    <el-button
                                        @click="clone(props.row._id)"
                                        class="btn ml-1"
                                        title="Clone"
                                        :loading="cloning[props.row._id]">
                                            <fa icon="copy"/>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="Delete" placement="top" v-if="(user.admin || (user.roles && user.roles[eventId] && user.roles[eventId].editRegistrationTypes))">
                                    <el-button
                                        @click="remove(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import _ from 'lodash'
import { mapState } from 'vuex'
import http from '../../http.js'
import download from 'downloadjs'

export default {
    data () {
        return {
            loading: false,
            nameFilter: '',
            allActivities: [],
            activities: [],
            downloading: false,
            cloning: {},
            eventId: null,
            repopulatingAll: false,
            repopulating: false
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted () {
        this.getActivites()
        this.eventId = this.$route.params.eventId
        // setTimeout(()=>{
        //     if( !this.user.admin){
        //         if(!(this.event.adminRoles && this.event.adminRoles[this.user._id] && this.event.adminRoles[this.user._id].viewRegistrants) ){
        //             this.$router.push('/dashboard/'+this.event._id)
        //         }
        //     }
        // },1000)
    },
    methods: {
        // async repopulateAll(){
        //     try {
        //         this.repopulatingAll = true
        //         const res = await http.post('/api/activities/repopulate-all', {
        //             event: this.$route.params.eventId
        //         });
        //         this.$notify(res.data.message)
        //     } catch (error) {
        //         this.$notify({
        //             type: 'danger',
        //             message: error.response.data.message
        //         })
        //     }
        //     this.repopulatingAll = false
        // },
        async repopulate(activityId){
            try {
                this.repopulating = true
                const res = await http.post('/api/activities/repopulate', {
                    event: this.$route.params.eventId,
                    activityId
                });

                this.activities.forEach(act =>{
                    if(act._id === activityId){
                        act.registeredAttendees = res.data.registeredAttendees
                    }
                })
                this.$notify(res.data.message)
            } catch (error) {
                this.$notify({
                    type: 'danger',
                    message: error.response.data.message
                })
            }
            this.repopulating = false
        },
        getActivites: async function () {
            this.loading = true
            try {
                const response = await this.$store.dispatch('getAll', {
                    path: 'activities',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })

                response.data.activities.forEach(activity => {
                    activity.registeredAttendees = activity.registeredAttendees.filter(attendee => attendee.status !== 'deleted')
                    activity.checkedInAttendees = activity.checkedInAttendees.filter(attendee => attendee.status !== 'deleted')
                })

                this.allActivities = response.data.activities
                this.filterActivities()
            } catch (e) {
                console.log('erorr getting activities')
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete the activity?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.activities = this.activities.filter(activity => activity._id !== id)
                    this.$store.dispatch('remove', { path: 'activities', id })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting activity')
            }
        },
        filterActivities: function (debounce = false) {
            const filter = () => {
                this.activities = this.allActivities.filter(activity => {
                    if (this.nameFilter.length) {
                        return activity.name.toUpperCase().indexOf(this.nameFilter.toUpperCase()) !== -1
                    }

                    return activity
                })
            }

            if (debounce) {
                let delay = _.debounce(() => {
                    filter()
                }, 300)
                delay()
            } else {
                filter()
            }
        },
        downloadActivities: async function () {
            this.downloading = true
            try {
                const response = await http.post('/api/activities/download', {
                    eventId: this.$route.params.eventId
                }, {
                    responseType: 'arraybuffer'
                })
                download(response.data, 'activities.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading activities')
            }
            this.downloading = false
        },
        clone: async function (id) {
            this.$set(this.cloning, id, true)
            try {
                const response = await http.post(`/api/activities/${id}/clone`)
                this.allActivities.push(response.data.activity)
                this.filterActivities()
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error cloning activity')
            }
            this.$set(this.cloning, id, false)
        },
        async toggleEnableScan(id){
            let activity = null
            this.allActivities.forEach(act => {
                if(act._id == id){
                    activity = act
                }
            })
            
            try {
                const response = await http.post(`/api/activities/${id}/toggle-enable-scan`)
                activity.scanEnabled = response.data.activity.scanEnabled
                
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error toggling scan')
            }
        }
    }
}
</script>